const popover = {
	/**
	 * Initializes Bootstrap popovers for elements with the 'data-bs-toggle="popover"' attribute.
	 *
	 * @returns {void}
	 */
	init: function () {
		const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
		[...popoverTriggerList].map((popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl));
	},
};

export default popover;
